<template>
  <v-dialog v-model="display" :width="dialogWidth">
    <template v-slot:activator="{}">
      <VTextFieldWithValidation
        v-model="dateInput"
        v-bind="textFieldProps"
        outlined
        dense
        :rules="rules"
        :label="label"
        :disabled="disabled"
        :loading="loading"
        append-icon="mdi-calendar"
        @change="dateInputChanged"
        @click:append="display = true"
      >
        <template v-slot:progress>
          <slot name="progress">
            <v-progress-linear
              color="primary"
              indeterminate
              absolute
              height="2"
            ></v-progress-linear>
          </slot>
        </template>
      </VTextFieldWithValidation>
    </template>
    <v-card>
      <v-card-text class="px-0 py-0">
        <v-date-picker
          v-model="date"
          elevation="0"
          v-bind="datePickerProps"
          full-width
        ></v-date-picker>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="actions" :parent="this">
          <v-btn color="grey" text @click.native="clearHandler">{{ clearText }}</v-btn>
          <v-btn color="primary" text @click="okHandler">{{ okText }}</v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { format, parse } from 'date-fns'
import VTextFieldWithValidation from '@/components/validators/VTextFieldWithValidation'

const DEFAULT_DATE = ''
const DEFAULT_DATE_FORMAT = 'yyyy-MM-dd'
const DEFAULT_DIALOG_WIDTH = 340
const DEFAULT_CLEAR_TEXT = 'SMAZAT'
const DEFAULT_OK_TEXT = 'OK'

export default {
  name: 'VDatePickerEditableWithValidation',
  components: { VTextFieldWithValidation },
  model: {
    prop: 'datetime',
    event: 'input',
  },
  props: {
    datetime: {
      type: [Date, String],
      default: null,
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    disabled: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
    },
    label: {
      type: String,
      default: '',
    },
    dialogWidth: {
      type: Number,
      default: DEFAULT_DIALOG_WIDTH,
    },
    dateFormat: {
      type: String,
      default: DEFAULT_DATE_FORMAT,
    },
    clearText: {
      type: String,
      default: DEFAULT_CLEAR_TEXT,
    },
    okText: {
      type: String,
      default: DEFAULT_OK_TEXT,
    },
    textFieldProps: {
      type: Object,
      default: null,
      required: false,
    },
    datePickerProps: {
      type: Object,
      default: null,
      required: false,
    },
    timePickerProps: {
      type: Object,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      dateInput: null,
      display: false,
      activeTab: 0,
      date: DEFAULT_DATE,
    }
  },
  computed: {
    dateTimeFormat() {
      return this.dateFormat
    },
    defaultDateTimeFormat() {
      return DEFAULT_DATE_FORMAT
    },
    formattedDatetime() {
      return this.selectedDatetime ? format(this.selectedDatetime, this.dateTimeFormat) : ''
    },
    selectedDatetime() {
      if (this.date) {
        let datetimeString = this.date
        return parse(datetimeString, this.defaultDateTimeFormat, new Date())
      } else {
        return null
      }
    },
    dateSelected() {
      return !this.date
    },
  },
  watch: {
    selectedDatetime: function () {
      this.$emit('input', this.selectedDatetime)
      this.dateInput = this.formattedDatetime
    },
    datetime: function () {
      this.init()
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if (!this.datetime) {
        return
      }
      let initDateTime = new Date(this.datetime)
      this.date = format(initDateTime, DEFAULT_DATE_FORMAT)
    },
    dateInputChanged() {
      try {
        let split = this.dateInput.split('.')
        let initDateTime = new Date(split[2], split[1] - 1, split[0])
        this.date = format(initDateTime, DEFAULT_DATE_FORMAT)
      } catch (e) {
        this.dateInput = null
        this.date = null
      }
    },
    okHandler() {
      this.resetPicker()
      this.$emit('input', this.selectedDatetime)
    },
    clearHandler() {
      this.resetPicker()
      this.date = DEFAULT_DATE
      this.$emit('input', null)
    },
    resetPicker() {
      this.display = false
      this.activeTab = 0
      if (this.$refs.timer) {
        this.$refs.timer.selectingHour = true
      }
    },
    showTimePicker() {
      this.activeTab = 1
    },
  },
}
</script>
